<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageapprovebusinessnew/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
